module.exports = __webpack_public_path__ + "img/Lisa_Chris_O_11.83ce27d2.jpg";